import { BlockTitle, Description, Terminal } from './components'
import './app.css'

function App() {
  return (
    <div className="App container">
      <BlockTitle title='OCBC Assignment' />
      <Description />
      <Terminal />
    </div >
  );
}

export default App;